var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Add T&E Code")]),
      _vm._v(" "),
      _c("time-expense-form", {
        attrs: { "is-unbound": true, "is-outlook": true, "is-marketing": false }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ec4ae0", { render: render, staticRenderFns: staticRenderFns })
  }
}